<template>
    <div>
        <!-- Sidebar -->
        <vs-sidebar
            click-not-close
            parent="#todo-app"
            :hidden-background="true"
            class="full-vs-sidebar items-no-padding"
            v-model="isSidebarActiveDist"
            position-right
        >
            <div class="mail-sidebar-content px-0 sm:pb-6 h-full">
                <div
                    class="flex flex-wrap items-center truncate email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg"
                >
                    <div class="flex mb-4 truncate">
                        <div class="flex items-center truncate">
                            <!-- Кнопка назад -->
                            <feather-icon
                                :icon="
                                    $vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'
                                "
                                @click="$emit('closesidebar')"
                                class="cursor-pointer mr-4"
                                svg-classes="w-6 h-6"
                            ></feather-icon>
                            <!-- Дисциплина -->
                            <h6 class="title title_head truncate">
                                {{ data.discipline }}

                            </h6>
                        </div>
                    </div>
                </div>
                <component
                    :is="'VuePerfectScrollbar'"
                    class="scroll-area-emcfull-content md:px-8 md:pb-8 px-6 pb-6"
                    :settings="settings"
                    :key="$vs.rtl"
                >
                    <h6 class="title mb-2">
                        {{ $t("credits") }}: {{ data.credit }}
                    </h6>

                    <div
                        class="vx-row my-4"
                        v-for="(item, i) in data.load_types"
                        :key="i + 's'"
                    >
                        <div class="vx-col w-full">
                            <!-- Вид учебной деятельности  -->
                            <vx-card class="lg:px-4">
                                <div class="lg:flex flex-wrap items-center">
                                    <span class="font-semibold"
                                        >{{ $t("typeEdu") }}:
                                    </span>
                                    <span class="lg:ml-2">{{
                                        item.load_type
                                    }}</span>
                                </div>

                                <div>
                                    <!-- Статус -->
                                    <vx-tooltip
                                        :text="item.listStatus[item.status]"
                                        position="bottom"
                                        class="flex items-center my-2"
                                        style="width: 145px"
                                    >
                                        <span class="font-semibold"
                                            >{{ $t("status") }}:
                                        </span>
                                        <div class="mx-2">
                                            <feather-icon
                                                :style="
                                                    statusColor[item.status - 1]
                                                "
                                                :icon="
                                                    statusIcons[item.status - 1]
                                                "
                                            ></feather-icon>
                                        </div>
                                    </vx-tooltip>
                                </div>
                                <!-- Язык изучения дицеплины -->
                                <div class="flex flex-wrap items-center mb-2 lg:mb-3">
                                    <span class="font-semibold text-sm lg:text-base w-1/2"
                                        >{{ $t("langEdu") }}:
                                    </span>

                                    <v-select
                                        class="w-full"
                                        :options="item.languages"
                                        v-model="item.language"
                                        :clearable="false"
                                        label="name"
                                        :disabled="item.status === 4"
                                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                        :placeholder="$t('language')"
                                        @search:blur="getTeachers(item)"
                                    />
                                </div>
                                <!-- Преподаватель  -->
                                <div class="flex flex-wrap items-center">
                                    <span class="font-semibold text-sm lg:text-base w-1/2"
                                        >{{ $t("teacher") }}:
                                    </span>
<!--                                    <a @click="kl()">-->
<!--                                        dssfdfassaasasassa-->
<!--                                    </a>-->
<!--                                    <div v-if="item.teacherList.length==1">-->
                                        <v-select
                                            v-if="item.teacherList.length==1"
                                            class="w-full"
                                            :options="item.teacherList"
                                            v-model="item.teacherList[0]"
                                            clearable
                                            label="name"
                                            :reduce="(item) => item.uid"
                                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                            :disabled="
                                            item.language === null ||
                                            item.status === 4
                                        "
                                            :placeholder="
                                            item.language !== null
                                                ? $t('teacher')
                                                : $t('selectLang')
                                        "
                                            @input="updateTeacher(item)"
                                        />

<!--                                    </div>-->
<!--                                    <div v-else>-->
                                        <v-select
                                            v-else
                                            class="w-full"
                                            style="width: 100%;"
                                            :options="item.teacherList"
                                            v-model="item.teacherName"
                                            clearable
                                            label="name"
                                            :reduce="(item) => item.uid"
                                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                            :disabled="
                                            item.language === null ||
                                            item.status === 4
                                        "
                                            :placeholder="
                                            item.language !== null
                                                ? $t('teacher')
                                                : $t('selectLang')
                                        "
                                            @input="updateTeacher(item)"
                                        />
                                    </div>

<!--                                </div>-->
                            </vx-card>
                        </div>
                    </div>
                </component>
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {mapGetters} from 'vuex'
export default {
    props: {
        data: {
            required: true,
            type: Object,
        },
        isSidebarActiveDist: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showThread: false,
            settings: {
                maxScrollbarLength: 80,
                wheelSpeed: 1,
            },
            selectLang: null,
            selectTeacher: null,
            teacherItems: [],
            statusIcons: [
                "AlertCircleIcon",
                "CheckSquareIcon",
                "XCircleIcon",
                "CheckCircleIcon",
                "EditIcon",
            ],
            statusColor: [
                "color: orange",
                "color: #0000ff",
                "color: red",
                "color: green",
                "color: #8000ff",
            ],
        };
    },
    watch: {
        isSidebarActiveDist(value) {
            if (!value) {
                this.$emit("closesidebar");
            } else {
                this.getAllTeachers();
            }
        },
    },
    computed:{
        ...mapGetters({
            USER: "user/STATE",
        }),
        isAdvisor(){
            return this.USER.roles.is_supervisor
        }
    },

    methods: {
        // Обработка одного эдемента
        getTeachers(item) {
            item.teacherName = null;
            // Находим индекс в гоавном массиве
            const idx = this.data.load_types.findIndex(
                (c) => c.uid === item.uid
            );
            // Добавляем поле teacher list в котором группируются фмо учителя
            this.data.load_types[idx]["teacherList"] = item.selection_teachers
                .filter((c) => c.language === item.language.name)
                .map((c) => {
                    return {
                        uid: c.uid,
                        name:
                            c.teacher.lastName +
                            " " +
                            c.teacher.firstName +
                            " " +
                            c.teacher.middleName,
                    };
                });
        },
        // Обработка всех элементов при запуске
        getAllTeachers() {
            this.data.load_types = this.data.load_types.map((type) => {
                return {
                    teacherList: type.selection_teachers

                        .filter((c) => c.language === type.language)

                        .map((c) => {
                            return {
                                uid: c.uid,
                                name:
                                    c.teacher.lastName +
                                    " " +
                                    c.teacher.firstName +
                                    " " +
                                    c.teacher.middleName,
                            };
                        }),
                    teacherName:
                        type.teacher !== null
                            ? type.teacher.lastName +
                              " " +
                              type.teacher.firstName +
                              " " +
                              type.teacher.middleName
                            : null,
                    ...type,
                };
            });
        },
        // Изменение учителя
        async updateTeacher(item) {
            try {
                this.$vs.loading();
                // Запрос на обновление
                const response = await this.$http.put(
                    `user/my_discipline/${ item.uid }/edit/`,
                    {
                        teacher_discipline: item.teacherName,
                    }
                );
                if (response.data.message === "ok") {
                    // Изменяю статус
                    if (this.$route.name === "registration-of-disciplines") {
                        item.status = 2;
                    } else {
                        item.status = 5;
                    }
                    if (item.teacherName === null) {
                        // Если поля сброшены
                        item.status = 1;
                        item.language = null;
                    }
                }
            } catch {
                this.$vs.notify({
                    title: this.$t("error") + "!",
                    color: "danger",
                });
            } finally {
                this.$vs.loading.close();
            }
        },
    },
    components: {
        VuePerfectScrollbar,
    },
};
</script>

<style lang="scss">
.full-vs-sidebar .vs-sidebar {
    max-width: 100%;
}

.scroll-area-emcfull-content {
    position: relative;
    width: 100%;
    height: calc(100% - 85px);
    .archive_link {
        color: #ffffff !important;
    }
}
@media only screen and (max-width: 900px) {
    .scroll-area-emcfull-content {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
}
@media only screen and (max-width: 520px) {
    .title_head{
        max-width: 260px;
    }
}
@media only screen and (max-width: 420px) {
    .title_head{
        max-width: 230px;
    }
}
@media only screen and (max-width: 330px) {
    .title_head{
        max-width: 200px;
    }
}
</style>
